import { Stack, Typography } from "@mui/material";
import { CloseCircle } from "iconsax-react";

interface IErrorAlert {
  msgTitle: string;
  msgDesc?: string;
}

export default function ErrorAlert({
  msgTitle,
  msgDesc,
}: Readonly<IErrorAlert>) {
  return (
    <Stack
      width="100%"
      bgcolor={(theme) => theme.palette.others.deadlineBg}
      color={(theme) => theme.palette.others.deadline}
      gap="2px"
      borderColor={(theme) => theme.palette.others.deadline}
      sx={{
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: "8px",
        py: "12px",
        px: "16px",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="start"
        gap="4px"
      >
        <CloseCircle size="24" variant="Outline" />
        <Typography variant="h6DemiBold">{msgTitle}</Typography>
      </Stack>
      <Typography px="24px" variant="captionRegular">
        {msgDesc}
      </Typography>
    </Stack>
  );
}
